<div class="auto-complete">
    <nz-input-group nzSearch nzSize="large">
        <input
            placeholder="Find a product"
            nz-input
            (input)="onChange($event)"
            [(ngModel)]="keyword"
            [nzAutocomplete]="auto"
        />
    </nz-input-group>
    <nz-autocomplete #auto>
        <nz-auto-option
            *ngFor="let product of filteredProducts"
            [nzValue]="product.label"
            (selectionChange)="fieldSelected($event, product)"
        >
            <div class="global-search-item">
                <div>
                    <span class="font-bold">{{ product.label }} </span>
                    <span *ngIf="product.subLabel">{{ product.subLabel }}</span>
                    <br />
                    <span
                        >${{ product.price }}
                        {{ product._id ? '    |    ID:' + product._id : '' }} |
                    </span>
                </div>
            </div>
        </nz-auto-option>
    </nz-autocomplete>
</div>
